import { createBrowserRouter, Outlet } from "react-router-dom";
import Protected from './components/Protected';
import Main from './pages/Main';
import Login from './pages/Login';
import Despachos from './pages/Despachos';
import Error from './pages/Error';
import Videos from './pages/Videos';
import Catalogo from './pages/Catalogo';
import AuthProvider from "./hooks/AuthProvider";
import Reacciones from "./pages/Reacciones";
import Dashboard from "./pages/Dashboard";
import Reportes from "./pages/Reportes";
import Transacciones from "./pages/Transacciones";
import Ordenes from "./pages/Ordenes";
import DetallePagos from "./pages/DetallePagos";
import Usuarios from "./pages/Usuarios";

const AuthWrapper = () => {

  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  )
}

export const router = createBrowserRouter([
  {
    element: <AuthWrapper />,
    children: [
      {
        path: '/',
        element: <Protected />,
        errorElement: <Error />,
        children: [
          {
            path: "",
            element: <Main />,
            children: [
              {
                path: "",
                element: <Dashboard />
              },
              {
                path: "dashboard",
                element: <Dashboard />
              },
              {
                path: "Despachos",
                element: <Despachos />
              },
              {
                path: 'videos',
                element: <Videos />
              },
              {
                path: 'catalogo',
                element: <Catalogo />
              },
              {
                path: 'reacciones',
                element: <Reacciones />
              },
              {
                path: 'transacciones',
                element: <Transacciones />
              },
              {
                path: 'ordenes',
                element: <Ordenes />
              },
              {
                path: 'usuarios',
                element: <Usuarios />
              }
            ]
          }
        ]
      },
      {
        path: '/login',
        element: <Login />
      },
      {
        path: '/reportes/:reporte',
        element: <Reportes />
      },
      {
        path: '/detallepago.aspx',
        element: <DetallePagos />
      }
    ]
  }
])